import get from 'lodash/get'

import ApiError, { ERROR_TYPES } from './ApiError'
import { isCancel } from 'axios'

export default class ApiErrors {
  constructor (sourceError) {
    this.sourceError = sourceError
  }

  get isRequestCancelled () {
    return isCancel(this.sourceError)
  }

  get message () {
    if (this.errors.length > 0) {
      return this.findFirstError().message
    }
  }

  get request () {
    return this.sourceError.request
  }

  get response () {
    return this.sourceError.response
  }

  get errors () {
    const errors = get(this.sourceError, 'response.data.errors')

    return Array.isArray(errors)
      ? errors.map(error => new ApiError(error))
      : [
        new ApiError({
          error: ERROR_TYPES.NETWORK,
          message: 'Network error'
        })
      ]
  }

  get responseStatus () {
    if (this.response != null) {
      return this.response.status
    }
  }

  findFirstSystemError () {
    return this.findSystemErrors()[0]
  }

  findSystemErrors () {
    return this.errors.filter(error => error.isSystemError)
  }

  findValidationErrors () {
    return this.errors.filter(error => error.isValidationError)
  }

  findFirstError () {
    const validationErrors = this.findValidationErrors()

    if (validationErrors.length) {
      return validationErrors[0]
    }

    const systemErrors = this.findSystemErrors()

    if (systemErrors.length) {
      return systemErrors[0]
    }
  }
}
